export default __webpack_public_path__ + "static/media/n-back-visivo-acustico-step2.13d4566f.svg";